/**
 * A Footer saying < current year > @ gogochart only.. lol
 */

import styled from 'styled-components';

const Footer = styled.div`
    // iphone 
    .iPhone{
        width: 100%;
        z-index: 9;
    }
    margin-left: auto;
    margin-right: auto;
    .exampleHolder{
        margin-left: auto;
    margin-right: auto;
    }
       
    .exampleAdPreview {
        padding: 12px;
        font-family: 'Montserrat';
        font-size: 14px;
        color: rgba(64, 55, 57, 1);
        text-align: justify;
        text-align: center;
    }

    .adExample__ad-example {
        width: 100%;
        max-width: 22rem;
        overflow: hidden;
        position: relative;
        margin-top: 3rem;
        }
        @media (min-width: 768px) {
        .adExample__ad-example {
            margin-top: 0;
            margin-right: 0; } }
        @media (min-width: 1281px) {
        .adExample__ad-example {
            /* max-width: 24rem; */
            } }
        .adExample__ad-example.centered__ad-example {
        margin-left: auto;
        margin-right: auto; }



    .container__ad-example {
        position: absolute;
        top: 34.15133%;
        width: width: 87.5%; 
        left: 6.1%; }

    .adExampleFull__ad-example .container__ad-example {
        top: 15.4%;
     }
    
    .searchTerm__ad-example {
        position: absolute;
        top: 14.9%;
        left: 14.2%;
        font-size: 0.7rem; }
        @media (min-width: 480px) {
            .searchTerm__ad-example {
            font-size: 0.8rem; } }


    .app__ad-example {
        padding: 3.787878787878788%;
        background: #fff; }
        
    .app__ad-example.isAd__ad-example {
        background: #EDF6FF; }


    .appSummary__ad-example {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center; }

    .appThumbnail__ad-example {
        width: 27.03583%;
        margin-right: 2.9316%;
        -ms-flex-negative: 0;
            flex-shrink: 0; }
    .appThumbnail__ad-example > img {
        border-radius: 16px; }

    .appName__ad-example {
        font-size: 1.05em;
        color: #333;
        line-height: 1.2;
        margin-bottom: 5px; }
        
    .appDetail__ad-example {
        font-family: "SF UI", helvetica, arial, sans-serif;
        font-size: 0.75rem; }
            
    .getButton__ad-example {
        position: relative;
        padding: 0.3rem 0.5rem;
        border: 1px solid #3E90F4;
        color: #3E90F4;
        font-size: 0.65rem;
        font-family: "SF UI", helvetica, arial, sans-serif;
        border-radius: 3px;
        line-height: 1; }
        .getButton__ad-example::before {
            content: '+';
            position: absolute;
            line-height: 1;
            font-size: 7px;
            font-weight: 400;
            top: 0;
            left: 1px; }

    .adSymbol__ad-example {
        display: inline-block;
        padding: 0 5px;
        background: #8EC5FE;
        color: #fff;
        border-radius: 2px;
        margin-right: 8px; }
            
    .publisher__ad-example {
        font-size: 0.9em;
        color: #666;
        line-height: 1.3;
        display: table;
        table-layout: fixed;
        width: 100%;
        white-space: nowrap; }

    .publisher__ad-example > span {
        display: table-cell;
        overflow: hidden;
        text-overflow: ellipsis; }

    .screenshotsContainer__ad-example {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: distribute;
            justify-content: space-around;
        margin-top: 4.09%;
        width: 100%;
        // padding-left: 10.3226%;
        // padding-right: 10.3226%; 
    }
        
    .screenshot__ad-example {
        width: 30%; 
    }
    .screenshot__ad-example > img {
        width: 100%; 
    }

    //end of iphone x
    .searchTerm__ad-example { top: 9.5%; left: 19.2%; z-index: 1002}
    .container__ad-example { top: 15.4%; width: 87.5%; }
`;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/AdPreview/Wrapper.js